import "../node_modules/video.js/dist/video-js.min.css";
import "../node_modules/videojs-contrib-ads/dist/videojs.ads.css";
import "../node_modules/videojs-ima/dist/videojs.ima.css";
//import "../css/custom-videojs.css";



import "script-loader!../node_modules/video.js/dist/video.min.js";

import "script-loader!../node_modules/videojs-contrib-ads/dist/videojs.ads.min.js";
import "script-loader!../node_modules/videojs-ima/dist/videojs.ima.min.js";
import "script-loader!../node_modules/videojs-playlist/dist/videojs-playlist.min.js";
// import "script-loader!../lib/videojs-youtube-master/dist/Youtube.min.js";
import "./titlebar.js";
import "./logo.js";


"use strict";
videojs.addLanguage('it',{
  "Play": "Play",
  "Pause": "Pausa",
  "Current Time": "Orario attuale",
  "Duration Time": "Durata",
  "Remaining Time": "Tempo rimanente",
  "Stream Type": "Tipo del Streaming",
  "LIVE": "LIVE",
  "Loaded": "Caricato",
  "Progress": "Stato",
  "Fullscreen": "Schermo intero",
  "Non-Fullscreen": "Chiudi schermo intero",
  "Mute": "Muto",
  "Unmute": "Audio",
  "Playback Rate": "Tasso di riproduzione",
  "Subtitles": "Sottotitoli",
  "subtitles off": "Senza sottotitoli",
  "Captions": "Sottotitoli non udenti",
  "captions off": "Senza sottotitoli non udenti",
  "Chapters": "Capitolo",
  "You aborted the media playback": "La riproduzione del filmato è stata interrotta.",
  "A network error caused the media download to fail part-way.": "Il download del filmato è stato interrotto a causa di un problema rete.",
  "The media could not be loaded, either because the server or network failed or because the format is not supported.": "Il filmato non può essere caricato a causa di un errore nel server o nella rete o perché il formato non viene supportato.",
  "The media playback was aborted due to a corruption problem or because the media used features your browser did not support.": "La riproduzione del filmato è stata interrotta a causa di un file danneggiato o per l’utilizzo di impostazioni non supportate dal browser.",
  "No compatible source was found for this media.": "Non ci sono fonti compatibili per questo filmato.",
  "Share": "Condividi",
  "Direct Link": "Link diretto",
  "Embed Code": "Incorpora",
  "Copy": "Copia",
  "Copied": "Copiato"
});

export function createPlayer(container, options) {
  var _default = {
    title: null,
    logo: {},
    style: "width: 100%; height:100%;",
    adTagUrl: null,
    adLabel: null,
    contribAdsSettings:{
      timeout:5000,
      prerollTimeout: 5000
    },
    videojsOptions: {
      controlBar: {
        volumePanel: {
          inline: false
        }
      }
    }

  };
  var _options = {};
  for (var attrname in _default) {
    _options[attrname] = _default[attrname];
  }
  for (var attrname in options) {
    if (attrname != "videojsOptions") {
      _options[attrname] = options[attrname];
    }
  }

  if (options.videojsOptions) {
    for (var attrname in options.videojsOptions) {
      _options.videojsOptions[attrname] = options.videojsOptions[attrname];
    }
  }

  var videotag = '<video style="/**STYLE**/" id="/**VIDEO_ID**/" class="video-js"  >\
        <p class="vjs-no-js">\
        To view this video please enable JavaScript, and consider upgrading to a web browser that\
        <a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>\
      </p>\
      </video>';


  var videoId = "video-" + Date.now();
  videotag = videotag.replace('/**VIDEO_ID**/', videoId);
  videotag = videotag.replace('/**STYLE**/', _options.style);





  document.querySelector(container).innerHTML = videotag;

  var player = videojs(videoId, _options.videojsOptions);


  if (_options.title) {

    player.addChild('TitleBar', {
      text: _options.title
    });
  }


  player.getChild('controlBar').addChild('CustomLogo', _options.logo);
  player.controlBar.el().insertBefore(player.controlBar.getChild("CustomLogo").el(), player.controlBar.getChild(
    "remainingTimeDisplay").el());


  // Remove controls from the player on iPad to stop native controls from stealing
  // our click
  var contentPlayer = document.getElementById(videoId);
  if ((navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/Android/i)) &&
    contentPlayer.hasAttribute('controls')) {
    contentPlayer.removeAttribute('controls');
  }

  // Initialize the ad container when the video player is clicked, but only the
  // first time it's clicked.
  var startEvent = 'click';
  if (navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/Android/i)) {
    startEvent = 'touchend';
  }

  if (_options.adTagUrl) {

    if (_options.adTagUrl.toLowerCase() == "spotx") {
      loadJs("//js.spotx.tv/directsdk/v1/"+_options.channelId+".js",function(){
        console.log("Play SpotX");
        player.controlBar.addClass('control-layer');
        player.ready(playSpotxAd(player));
      });
    } else {


      
      var imaOptions = {
        id: videoId,
        adTagUrl: _options.adTagUrl,
        adsManagerLoadedCallback : adsManagerLoadedCallback.bind(player),
        contribAdsSettings:_options.contribAdsSettings 
        // adTagUrl: 'http://pubads.g.doubleclick.net/gampad/ads?sz=640x480&' +
        //   'iu=/124319096/external/ad_rule_samples&ciu_szs=300x250&ad_rule=1&' +
        //   'impl=s&gdfp_req=1&env=vp&output=xml_vmap1&unviewed_position_start=1&' +
        //   'cust_params=sample_ar%3Dpremidpostpod%26deployment%3Dgmf-js&cmsid=496&' +
        //   'vid=short_onecue&correlator=',
        // adLabel:

      };
      if (_options.adLabel) {
        imaOptions.adLabel = _options.adLabel
      }
      player.ima(imaOptions);
      player.on('adserror', function(){
        console.log("EvolutionVideoPlayer: ads error");
        player.trigger("AdEvent_Error");
      });
      

      


    }
  }


  return player;
}

function adsManagerLoadedCallback(){
   
    var events = [
      google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
      google.ima.AdEvent.Type.CLICK,
      google.ima.AdEvent.Type.COMPLETE,
      google.ima.AdEvent.Type.FIRST_QUARTILE,
      google.ima.AdEvent.Type.LOADED,
      google.ima.AdEvent.Type.MIDPOINT,
      google.ima.AdEvent.Type.PAUSED,
      google.ima.AdEvent.Type.RESUMED,
      google.ima.AdEvent.Type.STARTED,
      google.ima.AdEvent.Type.THIRD_QUARTILE,
      google.ima.AdErrorEvent.Type.AD_ERROR
    ];
  
    for (var index = 0; index < events.length; index++) {
      var that = this;
      // debugger;
       this.ima.addEventListener(
          events[index],
          function(event){
            console.log("EvolutionVideoPlayer: AdEvent_" +  event.type, );
            that.trigger("AdEvent_" +  event.type )});
    }
     
}
 
function addClass(el, className) {
  if (el.classList) el.classList.add(className);
  else if (!hasClass(el, className)) el.className += ' ' + className;
}

function playSpotxAd(player) {
  // se presente lo share inibisco la pubblicità
  if (document.querySelector('.vjs-icon-share')) {

    document.querySelector('#ad-container').style.display = 'none';
  }

  var videoContainer = document.getElementById(player.id());
  var adSlot = document.createElement('div'); // Create an ad slot
  videoContainer.appendChild(adSlot);


  var videoSlot = videoContainer.querySelector("video") ||  videoContainer.querySelector("iframe video");
  
  addClass(adSlot, 'force-static'); // Force static positioning to override jw-player styling.
  adSlot.appendChild(videoSlot); // Move video element into ad slot

  var directAdOS = new SpotX.DirectAdOS({
    slot: adSlot,
    video_slot: videoSlot,
    hide_skin: true,
    autoplay: true,
    content_width: videoSlot.width,
    content_height: videoSlot.height
  });

  function onAdEnd(evt) {

    console.log("SPOTX AdEnd: "  + evt.message || "" );
    if (document.querySelector('#ad-container')) {

      document.querySelector('#ad-container').style.display = 'none';
    }
    videoSlot.parentNode.insertBefore(document.querySelector(".vjs-title-bar"), videoSlot.nextSibling);
  }

  directAdOS.subscribe(onAdEnd, 'AdStopped');
  directAdOS.subscribe(onAdEnd, 'AdError');
  directAdOS.subscribe(onAdEnd, 'AdSkipped');

  directAdOS.loadAd();
};

function loadJs( src, cb ){
  "use strict";
  var ref = document.getElementsByTagName( "script" )[ 0 ];
  var script = document.createElement( "script" );
  script.src = src;
  script.async = true;
  ref.parentNode.insertBefore( script, ref );
  if (cb && typeof(cb) === "function") {
    script.onload = cb;
  }
  return script;
};
//videojs


//////////////////
// WEBPACK FOOTER
// ./js/evolutionVideoPlayer.js
// module id = 3
// module chunks = 0